/**
 * Words sent from 4klabs.ai arrive in the URL's fragment (/start#fd=…), which never reaches a server, a CDN log or a
 * Referer. They must not reach GA4 or Clarity either, and both record the full URL, so this is the first thing main.tsx
 * imports and it imports nothing: the fragment leaves the address before any analytics can read it.
 */
const PREFIX = '#fd=';

let taken: string | null = null;

if (typeof window !== 'undefined' && window.location.hash.startsWith(PREFIX)) {
  taken = window.location.hash.slice(PREFIX.length);
  window.history.replaceState(window.history.state, '', window.location.pathname + window.location.search);
}

/** The fragment this page load arrived with, once. */
export function takeSiteFragment(): string | null {
  const fragment = taken;
  taken = null;
  return fragment;
}
